import { useState } from "react";
import { FaTimes } from "react-icons/fa";
import api from "../../../../../utils/axiosInstance";
import { FILE_CATEGORIES } from "../../../../../utils/constants/fileCategories";
import { toast } from "../../../../../components/Toast/toast";
import { btn } from "../../../../../components/Button/buttonStyles";
import FormSelect from "../../../../../components/Form/FormSelect";

// Matches the multer filter in backend/middlewares/multerConfig.js.
const ALLOWED_TYPES = [
  "image/png",
  "image/jpeg",
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
];

const UploadQuotationFileModal = ({ quotationId, onClose, onSuccess }) => {
  const [category, setCategory] = useState("");
  const [note, setNote] = useState("");
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);

  const handleFileChange = (e) => {
    const selected = e.target.files[0];
    if (!selected) return;

    if (!ALLOWED_TYPES.includes(selected.type)) {
      toast.error("Invalid file type. Allowed: PNG, JPG, PDF, DOC, DOCX");
      e.target.value = "";
      return;
    }

    setFile(selected);
  };

  const handleUpload = async (e) => {
    e.preventDefault();
    if (!file) return toast.error("Please select a file");

    const formData = new FormData();
    formData.append("category", category);
    formData.append("note", note);
    formData.append("file", file);

    try {
      setUploading(true);
      await api.post(`/quotations/${quotationId}/files`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      toast.success("File uploaded successfully");
      onSuccess();
    } catch (err) {
      console.error("Upload failed:", err);
      toast.error(err.response?.data?.message || "Failed to upload file");
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 backdrop-blur-sm flex justify-center items-center z-50">
      <div className="bg-white w-full max-w-lg rounded-2xl shadow-xl p-6 relative">
        <div className="flex justify-between items-center border-b pb-3 mb-4">
          <h2 className="text-xl font-semibold text-gray-800">Upload File</h2>
          <button onClick={onClose} className="p-2 rounded-full hover:bg-gray-100">
            <FaTimes className="text-gray-500 text-lg" />
          </button>
        </div>

        <form onSubmit={handleUpload} className="space-y-5">
          <div>
            <label className="mb-1.5 block text-xs font-medium text-gray-600">Category</label>
            <FormSelect
              value={category}
              onChange={(e) => setCategory(e.target.value)}
              options={FILE_CATEGORIES}
              placeholder="Select a category"
            />
          </div>

          <div>
            <label className="mb-1.5 block text-xs font-medium text-gray-600">Note</label>
            <textarea
              className="w-full border border-gray-300 rounded-md px-3 py-2"
              rows="3"
              placeholder="Optional note"
              value={note}
              onChange={(e) => setNote(e.target.value)}
            />
          </div>

          <div>
            <label className="mb-1.5 block text-xs font-medium text-gray-600">
              File <span className="text-danger-500">*</span>
            </label>
            <input
              type="file"
              accept=".png,.jpg,.jpeg,.pdf,.doc,.docx"
              onChange={handleFileChange}
              required
              className="block w-full border border-gray-300 rounded-md"
            />
            <p className="text-xs text-gray-500 mt-1">Supported: PNG, JPG, PDF, DOC, DOCX (Max 150MB)</p>
          </div>

          <div className="pt-3 flex justify-end gap-3">
            <button type="button" onClick={onClose} className={btn("secondary", "sm")}>
              Cancel
            </button>
            <button
              type="submit"
              disabled={uploading}
              className={btn("primary", "sm")}
            >
              {uploading ? "Uploading..." : "Upload"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default UploadQuotationFileModal;
